import {
  MRT_ColumnDef,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table"
import { useAppSelector } from "../../../redux/hooks"
import { Box } from "@mui/material"
import { defaultTableProps } from "../ResourceBudgetTable/constants"
import SortIcon from "@mui/icons-material/Sort"
import { useSelector, useDispatch } from "react-redux"
import { setHuddleActiveOpportuntiesRows } from "../../../redux/slices/huddleSlice"
import { useEffect } from "react"
import { assignTableId } from "../../../../helper/utils"

type tableProps = {
  columns: MRT_ColumnDef<any>[]
  data: {}[]
  enableEditing?: boolean
  blurHandler?: any
}

export const ActiveOpportunitiesTable = (props: tableProps) => {
  const dispatch = useDispatch()

  const { columns, data, enableEditing, blurHandler } = props
  const loading = useAppSelector((state) => state.app.loading)

  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })

  const table = useMaterialReactTable({
    ...defaultTableProps,
    columns: columns,
    data: data,
    enableSorting: true,
    enableMultiSort: false,
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        backgroundColor: "#1A428A",
        color: "#fff",
        fontWeight: "bold",
        height: "32px",
        boxShadow: " #00000022 1.95px  0px 2.6px",
      },
    },
    muiTableContainerProps: {
      sx: {
        borderRadius: "none",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
      },
    },
    icons: {
      ArrowDownwardIcon: () => <SortIcon sx={{ color: "#fff", ml: "7px" }} />,
    },
    muiTableBodyCellProps: ({ cell, table }) => {
      return {
        align: "center",
        onClick: () => table.setEditingCell(cell),
        sx: {
          height: "48px",
          boxShadow: "#00000022 1.95px 0px 2.6px",
          color: "black",
        },
      }
    },
    state: {
      isLoading: loading,
      columnVisibility: { Actions: false },
      // columnPinning: {
      //     left: ["provider_name", "provider_type"],
      // },
    },
  })

  useEffect(() => {
    dispatch(
      setHuddleActiveOpportuntiesRows(table?.getPrePaginationRowModel().rows),
    )
  }, [maevaSelectedPracticesNoAll])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        position: "relative",
        // border: "1px solid red"
      }}
    >
      <MaterialReactTable table={table} />
    </Box>
  )
}
